export enum ReportDataSet {
  Portfolio = 'P',
  Benchmark = 'B',
  Active = 'D',
}

export enum RiskMetricId {
  TotalRiskPortfolio = 'total_risk_p',
  TotalRiskBenchmark = 'total_risk_b',
  TotalRiskActive = 'total_risk_d',
  VaR = 'var',
  CVaR = 'cvar',
}
const RiskMetricIdValues = Object.values(RiskMetricId);
export function isRiskMetricId(value: string): value is RiskMetricId {
  // Type assertion is necessary because Object.values(USState) returns USState[]
  // and includes() expects a parameter of type USState, not string
  return RiskMetricIdValues.includes(value as any)
}
